import OadpEntityButtonSettingTable from './oadp-entity-button-setting-table';
export default OadpEntityButtonSettingTable;
